
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Layers from "slotworks/graphics/layers/layers";

export default class DebugSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "Debug";

    private debugText: PIXI.Text;

    public changeSymbol() {
        if (!this.debugText) {
            this.debugText = new PIXI.Text("", {
                fontSize: 8,
                fill: 0xff0000
            });

            Layers.Debug.add(this.debugText);
        }

        this.debugText.text = this.symbol.gridPosition.x + ", " + this.symbol.gridPosition.y + " : " + this.symbol.symbolId;
    }

    public updateTransform(): void {
        if (this.debugText) {

            const symbolTransform = this.symbol.getTransform();

            this.debugText.x = symbolTransform.x + this.matrixLayer.container.x - Layers.Debug.container.x;
            this.debugText.y = symbolTransform.y + this.matrixLayer.container.y - Layers.Debug.container.y + 50;
        }
    }
}
